/* eslint-disable no-param-reassign */
import produce from 'immer';
import { PARTNERS_REQUEST, PARTNERS_SUCCESS, PARTNERS_FAILURE, SWITCH_PARTNER } from 'src/store/actions/partnerActions';
import { LOGOUT } from 'src/store/actions/accountActions';
import axios from 'src/http/fetchClient';

const initialState = {
  partners: null,
  activePartner: null
};

const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTNERS_REQUEST: {
      return produce(state, (draft) => {
        draft.partners = null;
      });
    }

    case PARTNERS_SUCCESS: {
      const { partners } = action.payload;
      return produce(state, (draft) => {
        draft.partners = partners || [];
        const switchPartner =
          state.activePartner == null ||
          !partners?.length ||
          partners.filter((partner) => partner.id === state.activePartner.id).length === 0;

        if (switchPartner && partners?.length > 0) {
          const [firstPartner] = partners;
          draft.activePartner = firstPartner;
          localStorage.setItem('activePartnerId', firstPartner.id);
        } else if (state.activePartner) {
          localStorage.setItem('activePartnerId', state.activePartner.id);
        }
      });
    }

    case PARTNERS_FAILURE: {
      return produce(state, (draft) => {
        draft.partners = null;
        draft.activePartner = null;
        // FIXME: this can potentially cause a bug.
        localStorage.removeItem('activePartnerId');
      });
    }

    case SWITCH_PARTNER: {
      const { partner } = action.payload;

      return produce(state, (draft) => {
        draft.activePartner = partner;
        // axios.defaults.headers.common['X-PARTNER-ID'] = partner.id;
        localStorage.setItem('activePartnerId', partner.id);
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.partners = null;
        draft.activePartner = null;
        localStorage.removeItem('activePartnerId');
      });
    }

    default: {
      return state;
    }
  }
};

export default partnerReducer;
